module.exports = {
    vueSerAuth: require('./vueSerAuth'),
    vueLic: require('./vueLic')
};
